import {CircleFlag} from 'react-circle-flags'

export const languageMap = {
  en: {
    id: 'en',
    textShort: 'EN',
    text: 'English',
    image: <CircleFlag countryCode='gb' />,
  },
  de: {
    id: 'de',
    textShort: 'DE',
    text: 'Deutsch',
    image: <CircleFlag countryCode='de' />,
  },
}
